import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material"
import type { ContactListFormData } from "@crm-src/lib/contact-lists-api"

interface EditGroupDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  formData: ContactListFormData
  onFormDataChange: (data: ContactListFormData) => void
  onSubmit: () => void
}

export function EditGroupDialog({
  open,
  onOpenChange,
  formData,
  onFormDataChange,
  onSubmit,
}: EditGroupDialogProps) {
  return (
    <Dialog open={open} onClose={() => onOpenChange(false)} maxWidth="sm" fullWidth>
      <DialogTitle>Edit Contact Group</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          Update the group information
        </DialogContentText>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, py: 2 }}>
          <TextField
            id="edit-name"
            label="Name *"
            size="small"
            fullWidth
            value={formData.name}
            onChange={(e) => onFormDataChange({ ...formData, name: e.target.value })}
          />
          <TextField
            id="edit-description"
            label="Description"
            size="small"
            fullWidth
            multiline
            minRows={3}
            value={formData.description}
            onChange={(e) => onFormDataChange({ ...formData, description: e.target.value })}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="inherit" onClick={() => onOpenChange(false)}>
          Cancel
        </Button>
        <Button variant="contained" onClick={onSubmit}>Update Group</Button>
      </DialogActions>
    </Dialog>
  )
}
